// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Grid,
//     TextField,
//     Typography,
//     Select,
//     MenuItem,
//     FormControl,
//     InputLabel,
//     RadioGroup,
//     FormControlLabel,
//     Radio,
//     Button,
//     Switch,
//     Checkbox,
//     IconButton,
// } from '@mui/material';
// import SendIcon from '@mui/icons-material/Send';
// import CancelIcon from '@mui/icons-material/Cancel';
// import TestIcon from '@mui/icons-material/Quiz';
// import DeleteIcon from '@mui/icons-material/Delete';

// const SendSmsForm: React.FC = () => {
//     const [formData, setFormData] = useState({
//         sendType: 'Random',
//         number: '',
//         uniqueId: 'TX2021',
//         templateName: '',
//         header: '',
//         unicode: 'No',
//         message: '',
//         enableShortUrl: false,
//         destinationUrl: '',
//         campaignType: 'Promotional',
//         campaignName: '',
//         businessName: '',
//         scheduleCampaign: false,
//         splitCampaign: false,
//         csvFile: null as File | null,
//     });

//     const [numberCount, setNumberCount] = useState(0);
//     const [variables, setVariables] = useState<{ [key: string]: string }>({});

//     // Detect {#var#} placeholders in the message
//     useEffect(() => {
//         const detectedVars = formData.message.match(/{#(.*?)#}/g) || [];
//         const newVariables: { [key: string]: string } = {};

//         detectedVars.forEach((variable) => {
//             if (!(variable in variables)) {
//                 newVariables[variable] = ''; // Initialize with empty values
//             }
//         });

//         setVariables((prev) => ({ ...prev, ...newVariables }));
//     }, [formData.message]);

//     const handleVariableChange = (key: string, value: string) => {
//         setVariables((prev) => ({ ...prev, [key]: value }));
//     };

//     const handleRemoveVariable = (variable: string) => {
//         const updatedVariables = { ...variables };
//         delete updatedVariables[variable];
//         setVariables(updatedVariables);

//         // Remove variable from message as well
//         setFormData((prev) => ({
//             ...prev,
//             message: prev.message.replace(variable, ''),
//         }));
//     };

//     const addNewVariable = () => {
//         const newVariable = `var${Object.keys(variables).length + 1}`;
//         setVariables({
//             ...variables,
//             [newVariable]: '',
//         });
//     };

//     const handleChange = (field: string, value: string | boolean | File | null) => {
//         if (field === 'number') {
//             const cleanedNumbers = value.toString().split(/[\s,]+/).filter((num) => /^\d{8,13}$/.test(num));
//             setNumberCount(cleanedNumbers.length);
//         }
//         setFormData({ ...formData, [field]: value });
//     };

//     return (
//         <Box sx={{ padding: 4, maxWidth: 800, margin: '0 auto', backgroundColor: '#f5f5f5', borderRadius: 2, boxShadow: 3 }}>
//             <Typography variant="h5" fontWeight="bold" sx={{ marginBottom: 2 }}>
//                 Send SMS
//             </Typography>

//             <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                     <FormControl>
//                         <RadioGroup
//                             row
//                             value={formData.sendType}
//                             onChange={(e) => handleChange('sendType', e.target.value)}
//                         >
//                             <FormControlLabel value="Random" control={<Radio />} label="Random" />
//                             <FormControlLabel value="CSV Upload" control={<Radio />} label="CSV Upload" />
//                         </RadioGroup>
//                     </FormControl>
//                 </Grid>

//                 {formData.sendType === 'Random' ? (
//                     <Grid item xs={12}>
//                         <TextField
//                             label={`Number (Count: ${numberCount})`}
//                             variant="outlined"
//                             size="small"
//                             fullWidth
//                             placeholder="Enter numbers separated by commas or spaces"
//                             value={formData.number}
//                             onChange={(e) => handleChange('number', e.target.value)}
//                         />
//                     </Grid>
//                 ) : (
//                     <Grid item xs={12}>
//                         <input
//                             type="file"
//                             accept=".csv"
//                             onChange={(e) => handleChange('csvFile', e.target.files ? e.target.files[0] : null)}
//                         />
//                     </Grid>
//                 )}

//                 <Grid item xs={6}>
//                     <TextField
//                         label="Unique ID"
//                         variant="outlined"
//                         size="small"
//                         fullWidth
//                         value={formData.uniqueId}
//                         onChange={(e) => handleChange('uniqueId', e.target.value)}
//                     />
//                 </Grid>

//                 <Grid item xs={6}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Template Name</InputLabel>
//                         <Select
//                             value={formData.templateName}
//                             onChange={(e) => handleChange('templateName', e.target.value)}
//                         >
//                             <MenuItem value="Template A">Template A</MenuItem>
//                             <MenuItem value="Template B">Template B</MenuItem>
//                             <MenuItem value="Template C">Template C</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 <Grid item xs={6}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Header</InputLabel>
//                         <Select
//                             value={formData.header}
//                             onChange={(e) => handleChange('header', e.target.value)}
//                         >
//                             <MenuItem value="Header 1">Header 1</MenuItem>
//                             <MenuItem value="Header 2">Header 2</MenuItem>
//                             <MenuItem value="Header 3">Header 3</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 <Grid item xs={6}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Unicode</InputLabel>
//                         <Select
//                             value={formData.unicode}
//                             onChange={(e) => handleChange('unicode', e.target.value)}
//                         >
//                             <MenuItem value="Yes">Yes</MenuItem>
//                             <MenuItem value="No">No</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 <Grid item xs={12}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Typography variant="subtitle1" fontWeight="bold">
//                             Message
//                         </Typography>
//                         <Typography sx={{ fontSize: 14, color: '#999' }}>
//                             {formData.message.length}/160
//                         </Typography>
//                     </Box>
//                     <TextField
//                         multiline
//                         rows={4}
//                         variant="outlined"
//                         size="small"
//                         fullWidth
//                         value={formData.message}
//                         onChange={(e) => handleChange('message', e.target.value)}
//                         sx={{ marginTop: 1 }}
//                         placeholder="Enter your message with {#var#} placeholders"
//                     />
//                 </Grid>
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         justifyContent: 'flex-end',
//                         marginTop: 1,
//                         paddingLeft:'659px'
//                     }}
//                 >
//                     <Button 
//                    onClick={addNewVariable}
//                     >Add Body</Button>
//                 </Box>
//                 {/* Dynamic Variable Inputs */}
//                 {Object.keys(variables).length > 0 && (
//                     <Grid item xs={12}>
//                         <Typography variant="h6" fontWeight="bold" sx={{ marginTop: 2 }}>
//                             Body Variables
//                         </Typography>
//                         <Grid container spacing={2} sx={{ marginTop: 1 }}>
//                             {Object.keys(variables).map((variable, index) => (
//                                 <Grid item xs={12} md={6} key={index}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <TextField
//                                             label={`Variable ${variable}`}
//                                             variant="outlined"
//                                             size="small"
//                                             fullWidth
//                                             value={variables[variable]}
//                                             onChange={(e) => handleVariableChange(variable, e.target.value)}
//                                             placeholder={`Enter value for ${variable}`}
//                                         />
//                                         <IconButton onClick={() => handleRemoveVariable(variable)} color="error">
//                                             <DeleteIcon />
//                                         </IconButton>
//                                     </Box>
//                                 </Grid>
//                             ))}
//                         </Grid>
//                     </Grid>
//                 )}

//                 <Grid item xs={12}>
//                     <FormControlLabel
//                         control={
//                             <Switch
//                                 checked={formData.enableShortUrl}
//                                 onChange={(e) => handleChange('enableShortUrl', e.target.checked)}
//                             />
//                         }
//                         label="Enable Short URL"
//                     />
//                     {formData.enableShortUrl && (
//                         <>
//                             <TextField
//                                 label="Destination URL"
//                                 variant="outlined"
//                                 size="small"
//                                 fullWidth
//                                 sx={{ marginTop: 2 }}
//                                 value={formData.destinationUrl}
//                                 onChange={(e) => handleChange('destinationUrl', e.target.value)}
//                             />
//                             <Typography
//                                 sx={{
//                                     color: 'red',
//                                     fontSize: 14,
//                                     marginTop: '8px',
//                                 }}
//                             >
//                                 The ShortUrl will acquire 30 alphabet characters.
//                             </Typography>
//                         </>
//                     )}
//                 </Grid>

//                 <Grid item xs={12}>
//                     <FormControl>
//                         <RadioGroup
//                             row
//                             value={formData.campaignType}
//                             onChange={(e) => handleChange('campaignType', e.target.value)}
//                         >
//                             <FormControlLabel value="Promotional" control={<Radio />} label="Promotional (25 Credits)" />
//                             <FormControlLabel value="Transactional" control={<Radio />} label="Transactional (9 Credits)" />
//                         </RadioGroup>
//                     </FormControl>
//                 </Grid>

//                 <Grid item xs={6}>
//                     <TextField
//                         label="Campaign Name"
//                         placeholder="Enter campaign name for better reporting"
//                         variant="outlined"
//                         size="small"
//                         fullWidth
//                         value={formData.campaignName}
//                         onChange={(e) => handleChange('campaignName', e.target.value)}
//                     />
//                 </Grid>

//                 <Grid item xs={6}>
//                     <TextField
//                         label="Business Name"
//                         placeholder="Enter business name for better reporting"
//                         variant="outlined"
//                         size="small"
//                         fullWidth
//                         value={formData.businessName}
//                         onChange={(e) => handleChange('businessName', e.target.value)}
//                     />
//                 </Grid>

//                 <Grid item xs={6}>
//                     <FormControlLabel
//                         control={
//                             <Checkbox
//                                 checked={formData.scheduleCampaign}
//                                 onChange={(e) => handleChange('scheduleCampaign', e.target.checked)}
//                             />
//                         }
//                         label="Schedule Campaign"
//                     />
//                 </Grid>

//                 <Grid item xs={6}>
//                     <FormControlLabel
//                         control={
//                             <Checkbox
//                                 checked={formData.splitCampaign}
//                                 onChange={(e) => handleChange('splitCampaign', e.target.checked)}
//                             />
//                         }
//                         label="Split Campaign"
//                     />
//                 </Grid>

//                 <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//                     <Button
//                         variant="outlined"
//                         color="error"
//                         startIcon={<CancelIcon />}
//                         onClick={() => alert('Form cancelled')}
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         variant="contained"
//                         color="secondary"
//                         startIcon={<TestIcon />}
//                         onClick={() => alert('Test message sent')}
//                     >
//                         Test
//                     </Button>
//                     <Button
//                         variant="contained"
//                         color="primary"
//                         startIcon={<SendIcon />}
//                         onClick={() => alert('SMS sent')}
//                     >
//                         Send
//                     </Button>
//                 </Grid>
//             </Grid>
//         </Box>
//     );
// };

// export default SendSmsForm;


import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import { SmsActions } from '../../Services/_actions/SMS/sms.actions.ts';
import { useSnackBar } from '../../components/FlowBuilder/Common/SnackBar/index.tsx';
import LoadingButton from '../Shared/Loading/index.tsx';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';

const SendSmsForm: React.FC = () => {
    const location = useLocation();
    const actions = SmsActions();
    const navigate = useNavigate();
    const { showSnackBar } = useSnackBar();
    const [isLoading, setIsLoading] = useState(false);
    const smsData = location?.state?.sms;

    // Initializing form state with SMS template data or defaults
    const [formData, setFormData] = useState({
        message: smsData?.content || '',
        recipients: '',
        header: smsData?.headers?.[0] || '',
        campaignType: 'Promotional',
        templateId: smsData?.id || '',
    });

    const [numberCount, setNumberCount] = useState(0);
    const [bodyParams, setBodyParams] = useState<{ varKey: any, varValue: any }[]>([]);

    useEffect(() => {
        // Extract and prepare body parameters based on the template vars
        if (smsData?.var) {
            const initialParams = Object.keys(smsData?.var)?.map((varKey) => ({
                varKey: varKey,
                varValue: '', // Initialize empty to allow user input
            }));
            setBodyParams(initialParams);
        }
    }, [smsData]);

    const handleParamChange = (index, value) => {
        const updatedParams = [...bodyParams];
        updatedParams[index].varValue = value;
        setBodyParams(updatedParams);
    };

    const handleChange = (field: string, value: string) => {
        if (field === 'recipients') {
            const cleanedNumbers = value
                .split(/[\s,]+/)
                .filter((num) => /^\d{8,13}$/.test(num)); // Validating phone numbers
            setNumberCount(cleanedNumbers.length);
        }
        setFormData({ ...formData, [field]: value });
    };

    const handleSendSms = async () => {
        if (!formData.header) {
            showSnackBar('Please select a Header.', 'error');
            return;
        }
        if (!formData.campaignType) {
            showSnackBar('Please select a Campaign Type.', 'error');
            return;
        }
        if (!formData?.recipients) {
            showSnackBar('Please enter at least one recipient number.', 'error');
            return;
        }
        const emptyParams = bodyParams.some(param => param.varValue.trim() === '');
        if (emptyParams) {
            showSnackBar('Please fill in all parameter fields.', 'error');
            return;
        }
        setIsLoading(true);

        try {
            // Dynamically create params with variable mapping
            const recipientParams = formData?.recipients
                .split(/[\s,]+/)
                .filter((num) => num?.trim() !== '')
                .map((num) => {
                    const paramObj = { to: num?.trim() };
                    bodyParams.forEach((param, index) => {
                        paramObj[`var${index + 1}`] = param?.varValue;
                    });
                    return paramObj;
                });

            // Constructing payload
            const payload = {
                sender_id: formData?.header,
                route: formData?.campaignType?.toLowerCase(), // Converting to lowercase for consistency
                params: recipientParams,
                template_id: formData?.templateId,
            };

            // Sending SMS using actions
            const response = await actions.sendSms(payload);
            if (response.status === 200) {
                showSnackBar('SMS sent successfully', 'success');
                navigate('/r/sms/list'); // Redirect to SMS list after success
            } else {
                showSnackBar('Failed to send SMS', 'error');
            }
        } catch (error) {
            showSnackBar('An error occurred. Please try again.', 'error');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <Box sx={{ padding: 4, maxWidth: 800, margin: '0 auto', backgroundColor: '#f5f5f5', borderRadius: 2, boxShadow: 3 }}>
            <Typography variant="h5" fontWeight="bold" sx={{ marginBottom: 2 }}>
                Send SMS
            </Typography>

            <Grid container spacing={2}>
                {/* Recipients input */}
                <Grid item xs={12}>
                    <TextField
                        label={
                            <Typography component="span">
                                {`Recipients (Count: ${numberCount})`}<span style={{ color: 'red' }}>*</span>
                            </Typography>
                        }
                        // label={`Recipients (Count: ${numberCount})`}
                        variant="outlined"
                        size="small"
                        fullWidth
                        multiline
                        placeholder="Enter numbers separated by commas or spaces"
                        value={formData.recipients}
                        onChange={(e) => handleChange('recipients', e.target.value)}
                    />
                </Grid>

                {/* Header Selection */}
                <Grid item xs={6}>
                    <SearchableDropdown
                        options={Array.isArray(smsData?.headers) ? smsData.headers.map(header => ({ label: header, value: header })) : []}
                        value={formData.header ? { label: formData.header, value: formData.header } : null}
                        onChange={(selected) => handleChange('header', selected?.value)}
                        label={
                            <Typography component="span">
                                Header<span style={{ color: 'red' }}>*</span>
                            </Typography>
                        }
                        labelKey="label"
                        valueKey="value"
                    />

                </Grid>

                {/* Campaign Type */}
                <Grid item xs={6}>
                    <SearchableDropdown
                        options={[
                            { label: "Promotional", value: "Promotional" },
                            { label: "Transactional", value: "Transactional" }
                        ]}
                        value={formData?.campaignType ? { label: formData.campaignType, value: formData.campaignType } : null}
                        onChange={(selected) => handleChange('campaignType', selected?.value)}
                        label={
                            <Typography component="span">
                                Campaign Type<span style={{ color: 'red' }}>*</span>
                            </Typography>
                        }
                        labelKey="label"
                        valueKey="value"
                    />
                </Grid>

                {/* Message Input */}
                <Grid item xs={12}>
                    <TextField
                        multiline
                        rows={4}
                        variant="outlined"
                        size="small"
                        fullWidth
                        label="Message"
                        value={formData?.message}
                        disabled
                        // onChange={(e) => handleChange('message', e.target.value)}
                        placeholder="Modify the message if needed"
                    />
                </Grid>

                {/* Body Parameters */}
                {bodyParams?.map((param: { varKey: any, varValue: any }, index) => (
                    <Grid item xs={6} key={index}>
                        <TextField
                            label={
                                <Typography component="span">
                                    {`Parameter ${index + 1} (${param.varKey})`}<span style={{ color: 'red' }}>*</span>
                                </Typography>
                            }
                            // label={`Parameter ${index + 1} (${param.varKey})`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={param?.varValue}
                            onChange={(e) => handleParamChange(index, e.target.value)}
                        />
                    </Grid>
                ))}

                {/* Action buttons */}
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <LoadingButton
                        buttonName="Cancel"
                        variant="outlined"
                        onClickButton={() => navigate('/r/sms/list')}
                    />

                    <LoadingButton
                        buttonName="Send"
                        onClickButton={handleSendSms}
                        isLoading={isLoading}
                    />

                    {/* <Button
                        variant="outlined"
                        color="error"
                        startIcon={<CancelIcon />}
                        onClick={() => navigate('/r/sms/list')}
                    >
                        Cancel
                    </Button>
                    
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SendIcon />}
                        onClick={handleSendSms}
                    >
                        Send SMS
                    </Button> */}
                </Grid>
            </Grid>
        </Box>
    );
};

export default SendSmsForm;
